import { Flex, Box, Img, Divider, Text } from '@chakra-ui/react';
import logo from '../../assets/svg/logo_gier.svg';
import logoOsasco from '../../assets/photo/prefeituraOsascoNovo.png';
import logoSantos from '../../assets/photo/prefeituraSantos.png';
import logoCidadeInteligente from '../../assets/svg/logo_cidadeinteligente.svg';
import MenuProfile from './components/menuProfile';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useEffect, useState } from 'react';

function Header() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [sidebarFechada, SetSidebarFechada] = useState<boolean>(false)
  const dadosLocalStorage = localStorage.getItem("dadosUsuario");

  useEffect(() => {

    if (dadosLocalStorage) {
      window.addEventListener('sidebarAtualizada', () => {
        const dadosAtualizados = localStorage.getItem("dadosUsuario");
        if(dadosAtualizados) {
          const dadosLocal = JSON.parse(dadosAtualizados);
          SetSidebarFechada(dadosLocal.sidebarFechada)
        }
    })
    }
  }, []);

  const abrirModalSairAplicacao = () => {
    Swal.fire({
      icon: 'question',
      title: 'Deseja sair da aplicação?',
      text: 'Você tem certeza que deseja sair?',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      confirmButtonText: 'Sim, desejo sair',
      cancelButtonText: 'Não, desejo permanecer',
      cancelButtonColor: '#EDF2F7',    
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  const isLogoGier = ['cms-demo.acto.net.br', 'cms-dev.acto.net.br']
    .includes(window.location.hostname);

  const isLogoSantos = ['cms-santos.acto.net.br'].includes(window.location.hostname);

  const logoSrc = isLogoGier ? logo : isLogoSantos ? logoSantos : logoOsasco;

  return (
    <Flex
      bgColor="#fff"
      px="30px"
      height="100%"
      paddingLeft={sidebarFechada ? '140px' : '300px'}
      transition="padding-left 0.3s ease"
      maxHeight="76px"
      justifyContent="space-between"
      alignItems="center"
      borderBottom="1px solid #EAEDF3"
      boxShadow="0 1px 5px rgb(152 152 152 / 10%)"
    >
      <Flex flexDir="row" alignItems="center">
        <Box>
        <Img src={logoSrc} maxWidth="250px" height="50px" ml="30px" objectFit="contain" />
        {/* <Img src={logo} /> */}
        </Box>
        <Divider orientation="vertical" mx="10px" borderColor="#D5D5D5" height="30px" />
        <Box>
          {isLogoGier ? (
            <Text fontSize="lg" fontWeight="semibold" color="#2c3e50">
              Portal Educacional
            </Text>
          ) : (
            <Img
              src={logoCidadeInteligente}
              height="24px"
              objectFit="contain"
              alt="Cidade Inteligente"
            />
          )}
        </Box>
      </Flex>
      <Box height={'100px'}>
        {/* <MenuProfile onLogout={abrirModalSairAplicacao} /> */}
      </Box>
    </Flex>
  );
}

export default Header;
